export default __webpack_public_path__ + "static/media/gallery_13.f583daa5.jpg";